import {useQuery, UseQueryOptions} from '@tanstack/react-query';

import {getUser} from '../api';
import {QUERY__USERS} from '../queryKeys';
import {User} from '../types';

export const useGetUser = (
  userId: string,
  options?: Omit<UseQueryOptions<User>, 'queryKey' | 'queryFn'>,
) => {
  return useQuery({
    queryKey: [QUERY__USERS, userId],
    queryFn: () => getUser(userId),
    ...options,
  });
};
